import styled from 'styled-components';
import {Heading1} from '../../../utils/styles/typography';
import darkTheme from '../../../utils/styles/darkTheme';

export default styled.div`
  padding-bottom: 56.25%;
  width: 100%;
  position: relative;
  .spinner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
  }
  &.pausedContainer {
    position: absolute;
    top: 0;
  }
  .register-btn {
    background-color: ${darkTheme.surface};
    border-color: ${darkTheme.surface};
    font-weight: 700;
    &:hover {
      background-color: ${darkTheme.blue};
      border-color: ${darkTheme.blue};
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);
    }
  }
  .watch-btn {
    background-color: transparent;
    border: 1px solid #fff;
    font-weight: 700;
    border-radius: 5px;

    &:active,
    &:focus,
    &:focus-visible,
    &:focus-within {
      background: transparent !important;
    }
    &:hover {
      border: none;
      border-left: 1px solid #0dfff3;
      border-right: 1px solid #008aff;
      background-image: linear-gradient(90deg, #0dfff3, #008aff), linear-gradient(90deg, #0dfff3, #008aff);
      background-size: 100% 1px;
      background-position: 0 0, 0 100%;
      background-repeat: no-repeat;
    }
    .watch-icon {
      height: 12px;
      font-style: normal;
      font-weight: 900;
      font-size: 12px;
      line-height: 12px;
      align-items: center;
      text-align: center;
    }
  }
  .lock-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(90deg, rgba(0, 138, 255, 0.9) 0%, rgba(144, 67, 255, 0.9) 100%);
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0px 3px 1px rgba(0, 0, 0, 0.12))
      drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.2));
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    // &::after {
    //   position: absolute;
    //   content: '';
    //   height: 100%;
    //   width: 100%;
    //   background-color: #000;
    //   opacity: 0.4;
    //   z-index: 0;
    // }
    .lock-link {
      position: relative;
      z-index: 1;
      height: 8.5rem;
      width: 8.5rem;
      border: 3px solid #fff;
      border-radius: 8.5rem;
      background-color: #a7a7a791;
      display: flex;
      align-items: center;
      justify-content: center;
      .lock-icon {
        color: #fff;
        font-size: 3.5rem;
      }
    }
  }

  &.fullscreen-div {
    position: fixed;
    z-index: 10000;
    left: 0;
    height: 100%;
  }
`;

export const Time = styled(Heading1)`
  line-height: 40px;
  text-align: center;
  color: #ffffff;
`;

export const Subtitle = styled.div`
  font-size: 18px;
  line-height: 38.5px;
  font-weight: 400;
`;

export const Videoplayer = styled.div`
  .on-fullscreen {
    display: none;
  }

  .video-screen {
    position: relative;
  }
`;
